import React, { FC } from 'react'
import { StyledContent } from '../../privacyPolicy/containers/styles'
import { Content } from '../../../components/content/Content'
import PublicLayout from '../../publicLayout/containers/PublicLayout'

const SealTermsPage: FC = () => {
	return (
		<PublicLayout>
			<StyledContent>
				<Content slug={'seal-terms'} />
			</StyledContent>
		</PublicLayout>
	)
}

export default SealTermsPage
